export const common = {
  // Navigation
  nav_features: 'Fonctionnalités',
  nav_security: 'Sécurité',
  nav_community: 'Communauté',
  nav_join: 'Rejoindre',
  nav_back_home: 'Retour à l\'accueil',
  
  // Hero Section
  hero_title: 'FaceTrue',
  hero_subtitle: 'Réseau social à identité vérifiée',
  hero_description_1: 'Pas de faux comptes. Pas de harcèlement. Pas de violence.',
  hero_description_2: 'Pas de toxicité. Pas d\'extrémisme.',
  hero_description_3: '100% positif - Vérifié par IA.',
  
  // How It Works
  how_title: 'Comment ça marche',
  step1_title: 'Vérification faciale',
  step1_desc: 'Prenez un selfie → L\'IA vérifie l\'identité → Vérification instantanée',
  step1_badge: 'Pas de faux comptes',
  step2_title: 'Contenu propre',
  step2_desc: 'L\'IA filtre le contenu toxique, les arnaques, la violence 24/7',
  step2_badge: 'Filtrage IA 24/7',
  step3_title: 'Communauté mondiale',
  step3_desc: 'Publiez au niveau national ou mondial',
  step3_badge: 'Pays du monde',
  
  // Age-Based Content
  age_title: 'Contenu par âge',
  children_label: 'ENFANTS',
  children_title: 'Pour les enfants',
  children_feature1: 'Contenu éducatif sûr',
  children_feature2: 'Environnement convivial',
  children_feature3: 'Supervision parentale',
  adults_label: 'ADULTES',
  adults_title: 'Pour les adultes',
  adults_feature1: 'Discussions sociales',
  adults_feature2: 'Carrière & vie',
  adults_feature3: 'Connexions mondiales',
  seniors_label: 'SENIORS',
  seniors_title: 'Pour les seniors',
  seniors_feature1: 'Informations santé',
  seniors_feature2: 'Partage d\'expérience',
  seniors_feature3: 'Communauté de soutien',
  
  // Why Different
  why_title: 'Pourquoi choisir FaceTrue',
  why_feature1_title: '100% vraies personnes',
  why_feature1_desc: 'Vérification d\'identité par IA, élimination des faux comptes',
  why_feature2_title: 'Pas de violence & toxicité',
  why_feature2_desc: 'L\'IA filtre la violence, la toxicité, le harcèlement 24/7',
  why_feature3_title: 'Pas d\'extrémisme',
  why_feature3_desc: 'Élimination de toutes formes d\'extrémisme et de haine',
  why_feature4_title: '100% positif',
  why_feature4_desc: 'Uniquement du contenu positif, constructif et sain',
  why_feature5_title: 'Sûr pour tous les âges',
  why_feature5_desc: 'Classification intelligente du contenu, adapté à chaque âge',
  why_feature6_title: 'Système d\'avertissement à 3 drapeaux',
  why_feature6_desc: '<span class="text-yellow-400 font-bold">Drapeau Jaune</span> (1ère erreur) → <span class="text-red-400 font-bold">Drapeau Rouge</span> (2ème erreur) → <span class="text-gray-400 font-bold">Drapeau Noir</span> (3ème erreur - compte bloqué)',
  why_feature7_title: 'Système d\'évaluation par étoiles',
  why_feature7_desc: 'Partagez des informations, images, vidéos positives → Recevez des <span class="text-pink-400 font-bold">étoiles en forme de cœur rose</span> de la communauté',
  why_feature8_title: 'Publicité authentique',
  why_feature8_desc: 'L\'IA vérifie l\'authenticité des publicités. Les produits sont <span class="text-cyan-400 font-bold">vérifiés à la source</span> avant publication',
  
  // Video Demo
  video_title: 'Démo vidéo FaceTrue',
  video_subtitle: 'Voir comment ça marche',
  video_views: 'vues',
  video_close: 'Cliquez sur X pour fermer',
  video_demo_live: 'DÉMO EN DIRECT',
  video_info: 'Simulation de démo FaceTrue',
  video_info_cta: 'Cliquez sur Play pour voir la démo',
  video_update: 'La vraie vidéo sera mise à jour depuis Veo AI',
  
  // Video Stages
  scanning_title: 'Vérification en cours...',
  scanning_desc: 'L\'IA vérifie l\'identité',
  scanning_step1: 'Détection du visage',
  scanning_step2: 'Vérification IA',
  scanning_step3: 'Création du profil...',
  scanning_badge: '100% Vraies personnes',
  
  intro_step1_title: 'Vérification réussie',
  intro_step1_subtitle: '100% vraies personnes',
  intro_step2_title: 'Filtrage IA du contenu',
  intro_step2_subtitle: 'Pas de toxicité, pas de violence',
  intro_step3_title: 'Connexion mondiale',
  intro_step3_subtitle: '119 pays',
  intro_step4_title: '100% positif',
  intro_step4_subtitle: 'Uniquement du contenu sain',
  intro_step5_title: 'Sûr pour tous les âges',
  intro_step5_subtitle: 'Enfants • Adultes • Seniors',
  
  stats_title: 'Communauté FaceTrue',
  stats_subtitle: 'En pleine croissance',
  stats_users: 'Utilisateurs',
  stats_countries: 'Pays',
  stats_posts: 'Publications positives',
  stats_badge: '100% Positif',
  
  comparison_title: 'La différence',
  comparison_old: 'Anciens réseaux sociaux',
  comparison_old_1: 'Faux comptes',
  comparison_old_2: 'Contenu toxique',
  comparison_old_3: 'Violence',
  comparison_old_4: 'Arnaques',
  comparison_new: 'FaceTrue',
  comparison_new_1: '100% vraies personnes',
  comparison_new_2: 'Contenu propre',
  comparison_new_3: '100% positif',
  comparison_new_4: 'Sécurité IA',
  
  // Mock Posts
  mock_post1: 'Aujourd\'hui était génial ! Merci FaceTrue d\'avoir créé un environnement positif 🌟',
  mock_post2: 'Partage d\'expérience de travail à domicile efficace. Quelqu\'un a besoin de conseils ? 💼',
  mock_post3: 'Recette de pain sain pour toute la famille. Quelqu\'un a essayé ? 🍞',
  
  // CTA Section
  cta_title: 'Rejoignez maintenant',
  cta_subtitle: 'Inscrivez-vous à la version Beta de FaceTrue',
  cta_name: 'Nom complet',
  cta_email: 'Votre email',
  cta_button: 'S\'inscrire maintenant',
  cta_submitting: 'Envoi en cours...',
  cta_success: '🎉 Merci ! Nous vous contactons bientôt.',
  cta_error: '❌ Une erreur s\'est produite. Veuillez réessayer.',
  cta_privacy: 'Nous respectons votre vie privée',
  
  // Footer
  footer_copyright: '© 2025 FaceTrue Global Social Network',
  footer_creator: 'Créé par Ben Nguyen',
  footer_powered: 'Website Builder',
  
  // Time
  time_hours_ago: 'il y a {{count}} heures',
  time_day_ago: 'il y a {{count}} jours',
  
  // Children Page
  children_nav_features: 'Fonctionnalités',
  children_nav_safety: 'Sécurité',
  children_nav_activities: 'Activités',
  children_back_home: 'Retour à l\'accueil',
  
  children_hero_title: 'Bienvenue dans',
  children_hero_subtitle: 'petits anges',
  children_hero_desc: 'Un espace sûr, amusant et éducatif conçu spécialement pour les enfants !<br />Contenu 100% approuvé par les parents avec protection IA.',
  children_explore_btn: 'Explorer les fonctionnalités',
  children_safety_btn: 'Sécurité d\'abord',
  
  children_features_title: 'Fonctionnalités amusantes et éducatives',
  children_features_subtitle: 'Tout ce dont les enfants ont besoin pour apprendre, jouer et grandir en toute sécurité',
  
  children_feature1_title: 'Contenu éducatif',
  children_feature1_desc: 'Matériel d\'apprentissage adapté à l\'âge, quiz amusants et leçons interactives qui rendent l\'éducation passionnante.',
  
  children_feature2_title: 'Jeux sûrs',
  children_feature2_desc: 'Jeux soigneusement sélectionnés, amusants, éducatifs et totalement sûrs pour les enfants.',
  
  children_feature3_title: 'Activités créatives',
  children_feature3_desc: 'Dessin, coloriage, narration et autres activités créatives pour stimuler l\'imagination.',
  
  children_safety_title: 'La sécurité de votre enfant est notre priorité',
  children_safety_subtitle: 'Plusieurs couches de protection pour garantir une expérience sans souci',
  
  children_safety1_title: 'Filtrage de contenu IA',
  children_safety1_desc: 'Surveillance IA 24/7 garantit que seul le contenu approprié atteint les enfants.',
  
  children_safety2_title: 'Contrôle parental',
  children_safety2_desc: 'Les parents peuvent surveiller l\'activité et définir des limites de temps d\'utilisation saines.',
  
  children_safety3_title: 'Pas d\'étrangers',
  children_safety3_desc: 'Les enfants ne peuvent interagir qu\'avec des amis et des membres de la famille vérifiés.',
  
  children_activities_title: 'Découvrez les activités amusantes',
  children_activities_subtitle: 'Cliquez sur n\'importe quelle activité pour en savoir plus et commencer à jouer !',
  
  // 8 Activities
  activity1_title: 'Dessin et art',
  activity1_desc: 'Créez des œuvres d\'art incroyables avec des outils numériques',
  
  activity2_title: 'Jeux éducatifs',
  activity2_desc: 'Apprenez en vous amusant avec des jeux interactifs',
  
  activity3_title: 'Histoires et lecture',
  activity3_desc: 'Explorez des mondes magiques à travers des histoires',
  
  activity4_title: 'Musique et chansons',
  activity4_desc: 'Découvrez des chansons et mélodies amusantes',
  
  activity5_title: 'Photos et vidéos',
  activity5_desc: 'Capturez et partagez des moments spéciaux',
  
  activity6_title: 'Activités de groupe',
  activity6_desc: 'Jouez et apprenez ensemble avec des amis',
  
  activity7_title: 'Défis et récompenses',
  activity7_desc: 'Complétez des défis amusants et gagnez des récompenses',
  
  activity8_title: 'Événements spéciaux',
  activity8_desc: 'Rejoignez des activités saisonnières passionnantes',
  
  children_footer_copyright: '© 2025 Espace enfants FaceTrue',
  children_footer_desc: 'Un espace sûr pour que les enfants apprennent et jouent',
  
  children_modal_safe_badge: 'Sûr & Amusant',
  children_modal_what_you_can_do: 'Ce que vous pouvez faire',
  children_modal_start_btn: 'Commencer l\'activité',
  
  // Adults Page
  adults_nav_features: 'Fonctionnalités',
  adults_nav_community: 'Communauté',
  adults_nav_benefits: 'Avantages',
  adults_back_home: 'Retour à l\'accueil',
  
  adults_hero_title: 'Connectez-vous avec',
  adults_hero_subtitle: 'De vraies personnes, De vraies histoires',
  adults_hero_desc: 'Rejoignez une communauté d\'adultes vérifiés partageant des expériences authentiques,<br />construisant des connexions significatives et grandissant ensemble.',
  adults_explore_btn: 'Explorer les fonctionnalités',
  adults_join_btn: 'Rejoindre la communauté',
  
  adults_features_title: 'Tout ce dont vous avez besoin pour vous connecter',
  adults_features_subtitle: 'Réseautage professionnel, partage de style de vie et conversations significatives',
  
  adults_feature1_title: 'Carrière & Professionnel',
  adults_feature1_desc: 'Connectez-vous avec des professionnels, partagez des idées de carrière et découvrez des opportunités dans votre domaine.',
  
  adults_feature2_title: 'Style de vie & Loisirs',
  adults_feature2_desc: 'Partagez vos passions, loisirs et vie quotidienne avec des personnes partageant les mêmes idées dans le monde entier.',
  
  adults_feature3_title: 'Conversations profondes',
  adults_feature3_desc: 'Participez à des discussions significatives sur des sujets importants avec des utilisateurs vérifiés.',
  
  adults_community_title: 'Rejoignez une communauté mondiale',
  adults_community_subtitle: 'Connectez-vous avec des personnes qui partagent vos intérêts et valeurs',
  
  adults_community_entrepreneurs: 'Entrepreneurs',
  adults_community_entrepreneurs_desc: 'Idées d\'affaires & discussions de startup',
  adults_community_entrepreneurs_full: 'Connectez-vous avec des esprits innovants et des leaders d\'entreprise du monde entier. Partagez des idées de startup, discutez de stratégies commerciales et trouvez des cofondateurs potentiels.',
  adults_community_entrepreneurs_members: '125 000+ membres',
  adults_community_entrepreneurs_topic1: 'Idées de startup',
  adults_community_entrepreneurs_topic2: 'Financement & Investissement',
  adults_community_entrepreneurs_topic3: 'Stratégie commerciale',
  adults_community_entrepreneurs_topic4: 'Marketing & Croissance',
  adults_community_entrepreneurs_topic5: 'Développement de produits',
  
  adults_community_health: 'Santé & Fitness',
  adults_community_health_desc: 'Fitness, nutrition & bien-être mental',
  adults_community_health_full: 'Rejoignez une communauté de soutien axée sur la santé physique et mentale. Partagez des routines d\'entraînement, des conseils nutritionnels et des ressources de bien-être mental.',
  adults_community_health_members: '230 000+ membres',
  adults_community_health_topic1: 'Fitness & Entraînement',
  adults_community_health_topic2: 'Nutrition & Régimes',
  adults_community_health_topic3: 'Bien-être mental',
  adults_community_health_topic4: 'Yoga & Méditation',
  adults_community_health_topic5: 'Mode de vie sain',
  
  adults_community_arts: 'Arts & Culture',
  adults_community_arts_desc: 'Expression créative & échange culturel',
  adults_community_arts_full: 'Célébrez la créativité et la diversité culturelle. Partagez vos œuvres d\'art, découvrez de nouveaux artistes et participez à des discussions culturelles significatives.',
  adults_community_arts_members: '180 000+ membres',
  adults_community_arts_topic1: 'Arts visuels',
  adults_community_arts_topic2: 'Musique & Spectacles',
  adults_community_arts_topic3: 'Littérature',
  adults_community_arts_topic4: 'Cinéma & Photographie',
  adults_community_arts_topic5: 'Échange culturel',
  
  adults_community_travel: 'Voyage & Aventure',
  adults_community_travel_desc: 'Partagez des expériences & conseils de voyage',
  adults_community_travel_full: 'Explorez le monde avec des passionnés de voyage. Partagez des expériences de voyage, obtenez des recommandations de destinations et trouvez des compagnons de voyage.',
  adults_community_travel_members: '310 000+ membres',
  adults_community_travel_topic1: 'Conseils de voyage',
  adults_community_travel_topic2: 'Guides de destination',
  adults_community_travel_topic3: 'Voyage économique',
  adults_community_travel_topic4: 'Sports d\'aventure',
  adults_community_travel_topic5: 'Expériences culturelles',
  
  adults_community_food: 'Gastronomie & Cuisine',
  adults_community_food_desc: 'Recettes, restaurants & art culinaire',
  adults_community_food_full: 'Une communauté délicieuse pour les amateurs de gastronomie et les cuisiniers à domicile. Partagez des recettes, des critiques de restaurants et des aventures culinaires.',
  adults_community_food_members: '275 000+ membres',
  adults_community_food_topic1: 'Recettes & Cuisine',
  adults_community_food_topic2: 'Critiques de restaurants',
  adults_community_food_topic3: 'Pâtisserie & Desserts',
  adults_community_food_topic4: 'Cuisine internationale',
  adults_community_food_topic5: 'Photographie culinaire',
  
  adults_community_technology: 'Technologie',
  adults_community_technology_desc: 'Tendances technologiques & innovation',
  adults_community_technology_full: 'Restez à la pointe des tendances et innovations technologiques. Discutez des derniers gadgets, de la programmation, de l\'IA et de l\'avenir de la technologie.',
  adults_community_technology_members: '195 000+ membres',
  adults_community_technology_topic1: 'Programmation & Développement',
  adults_community_technology_topic2: 'IA & Apprentissage automatique',
  adults_community_technology_topic3: 'Gadgets & Critiques',
  adults_community_technology_topic4: 'Cybersécurité',
  adults_community_technology_topic5: 'Actualités technologiques',
  
  adults_community_parenting: 'Parentalité',
  adults_community_parenting_desc: 'Vie de famille & conseils parentaux',
  adults_community_parenting_full: 'Soutien et conseils pour les parents à toutes les étapes. Partagez des conseils parentaux, des défis et célébrez ensemble les étapes importantes.',
  adults_community_parenting_members: '340 000+ membres',
  adults_community_parenting_topic1: 'Conseils parentaux',
  adults_community_parenting_topic2: 'Développement de l\'enfant',
  adults_community_parenting_topic3: 'Éducation',
  adults_community_parenting_topic4: 'Activités familiales',
  adults_community_parenting_topic5: 'Équilibre travail-vie',
  
  adults_community_education: 'Éducation',
  adults_community_education_desc: 'Apprentissage & développement personnel',
  adults_community_education_full: 'Apprenants à vie, unissez-vous ! Partagez des ressources éducatives, discutez de stratégies d\'apprentissage et grandissez ensemble.',
  adults_community_education_members: '210 000+ membres',
  adults_community_education_topic1: 'Apprentissage en ligne',
  adults_community_education_topic2: 'Développement de carrière',
  adults_community_education_topic3: 'Apprentissage des langues',
  adults_community_education_topic4: 'Discussions académiques',
  adults_community_education_topic5: 'Conseils d\'étude',
  
  adults_community_active: 'Communautés actives',
  adults_community_join_btn: 'Rejoindre la communauté',
  adults_community_popular_topics: 'Sujets populaires',
  
  adults_benefits_title: 'Pourquoi les adultes choisissent FaceTrue',
  adults_benefits_subtitle: 'Un réseau social conçu pour des connexions adultes authentiques',
  
  adults_benefit1_title: 'Identités vérifiées',
  adults_benefit1_desc: 'Connectez-vous en toute confiance en sachant que tout le monde est réel.',
  
  adults_benefit2_title: 'Pas de toxicité',
  adults_benefit2_desc: 'Le filtrage IA élimine le harcèlement, les discours de haine et le contenu négatif.',
  
  adults_benefit3_title: 'Portée mondiale',
  adults_benefit3_desc: 'Connectez-vous avec des utilisateurs vérifiés dans 119 pays à travers le monde.',
  
  adults_benefit4_title: 'Priorité à la vie privée',
  adults_benefit4_desc: 'Vos données sont protégées par des mesures de sécurité de niveau entreprise.',
  
  adults_footer_copyright: '© 2025 Communauté adultes FaceTrue',
  adults_footer_desc: 'Connexions authentiques avec des adultes vérifiés dans le monde entier',
  
  // Seniors Page
  seniors_nav_features: 'Fonctionnalités',
  seniors_nav_health: 'Santé',
  seniors_nav_community: 'Communauté',
  seniors_back_home: 'Retour à l\'accueil',
  
  seniors_hero_title: 'Communauté',
  seniors_hero_subtitle: 'Conçue pour les seniors',
  seniors_hero_desc: 'Partagez votre sagesse, restez en contact avec vos proches,<br />et profitez d\'une communauté en ligne sûre et solidaire.',
  seniors_explore_btn: 'Explorer les fonctionnalités',
  seniors_safety_btn: 'Sécurité d\'abord',
  
  seniors_features_title: 'Ce que vous pouvez faire sur FaceTrue',
  seniors_features_subtitle: 'Connectez-vous, partagez et profitez d\'interactions significatives',
  
  seniors_feature1_title: 'Connexion familiale',
  seniors_feature1_desc: 'Restez en contact avec les membres de la famille dans le monde entier. Partagez des photos, des vidéos et des mises à jour de vie dans un environnement sûr.',
  
  seniors_feature2_title: 'Partagez votre histoire',
  seniors_feature2_desc: 'Partagez vos expériences de vie, votre sagesse et vos souvenirs avec les autres. Votre histoire compte et inspire.',
  
  seniors_feature3_title: 'Se faire de nouveaux amis',
  seniors_feature3_desc: 'Connectez-vous avec des personnes qui partagent vos intérêts et loisirs. Construisez des amitiés significatives.',
  
  seniors_feature4_title: 'Événements locaux',
  seniors_feature4_desc: 'Découvrez et participez à des activités et événements communautaires locaux près de chez vous.',
  
  seniors_feature5_title: 'Apprendre de nouvelles compétences',
  seniors_feature5_desc: 'Accédez à des tutoriels, des conseils et des guides sur la technologie, les loisirs et les compétences de vie quotidienne.',
  
  seniors_feature6_title: 'Groupes de soutien',
  seniors_feature6_desc: 'Rejoignez des communautés de soutien sur la santé, le bien-être et les défis de la vie. Vous n\'êtes pas seul.',
  
  seniors_health_title: 'Ressources santé & bien-être',
  seniors_health_subtitle: 'Restez informé et en bonne santé avec des informations fiables',
  
  seniors_health1_title: 'Conseils santé',
  seniors_health1_desc: 'Conseils santé quotidiens, conseils nutritionnels et guides d\'exercices conçus spécialement pour les seniors.',
  
  seniors_health2_title: 'Bien-être mental',
  seniors_health2_desc: 'Soutien au bien-être mental, pratiques de pleine conscience et gestion du stress.',
  
  seniors_health3_title: 'Rappels de médicaments',
  seniors_health3_desc: 'Définissez des rappels pour les médicaments et les rendez-vous de santé pour rester sur la bonne voie.',
  
  seniors_health4_title: 'Suivi d\'activité',
  seniors_health4_desc: 'Suivez vos activités quotidiennes, vos pas et célébrez vos étapes de santé.',
  
  seniors_community_title: 'Connectez-vous avec votre communauté',
  seniors_community_subtitle: 'Trouvez du soutien, partagez des expériences et créez des connexions significatives',
  
  seniors_community_family: 'Connexion familiale',
  seniors_community_family_desc: 'Restez proche des membres de la famille',
  seniors_community_family_full: 'Connectez-vous avec les membres de la famille à travers les générations. Partagez des photos, des vidéos et des souvenirs avec vos enfants et petits-enfants. Restez informé des événements et étapes importantes de la famille.',
  seniors_community_family_members: '2,8 millions de membres',
  seniors_community_family_topic1: 'Mises à jour familiales',
  seniors_community_family_topic2: 'Partage de photos',
  seniors_community_family_topic3: 'Appels vidéo',
  seniors_community_family_topic4: 'Événements familiaux',
  seniors_community_family_topic5: 'Histoires de petits-enfants',
  
  seniors_community_stories: 'Partagez votre histoire',
  seniors_community_stories_desc: 'Expériences de vie & sagesse',
  seniors_community_stories_full: 'Partagez vos expériences de vie, votre sagesse et vos histoires avec les jeunes générations. Vos souvenirs et leçons sont des trésors précieux qui peuvent inspirer et guider les autres.',
  seniors_community_stories_members: '1,9 million de membres',
  seniors_community_stories_topic1: 'Histoires de vie',
  seniors_community_stories_topic2: 'Événements historiques',
  seniors_community_stories_topic3: 'Expériences de carrière',
  seniors_community_stories_topic4: 'Leçons de vie',
  seniors_community_stories_topic5: 'Histoire familiale',
  
  seniors_community_friends: 'Se faire de nouveaux amis',
  seniors_community_friends_desc: 'Connectez-vous avec des amis du monde entier',
  seniors_community_friends_full: 'Rencontrez et connectez-vous avec d\'autres seniors qui partagent vos intérêts, loisirs et expériences de vie. Construisez des amitiés significatives et profitez de connexions sociales.',
  seniors_community_friends_members: '3,2 millions de membres',
  seniors_community_friends_topic1: 'Amitiés',
  seniors_community_friends_topic2: 'Activités sociales',
  seniors_community_friends_topic3: 'Intérêts communs',
  seniors_community_friends_topic4: 'Discussions de groupe',
  seniors_community_friends_topic5: 'Rencontres',
  
  seniors_community_events: 'Événements locaux',
  seniors_community_events_desc: 'Activités communautaires & rassemblements',
  seniors_community_events_full: 'Découvrez des événements, activités et rassemblements locaux conçus pour les seniors dans votre région. Restez actif et engagé avec votre communauté locale.',
  seniors_community_events_members: '1,5 million de membres',
  seniors_community_events_topic1: 'Événements communautaires',
  seniors_community_events_topic2: 'Centres pour seniors',
  seniors_community_events_topic3: 'Rassemblements sociaux',
  seniors_community_events_topic4: 'Activités locales',
  seniors_community_events_topic5: 'Ateliers',
  
  seniors_community_learning: 'Apprendre de nouvelles compétences',
  seniors_community_learning_desc: 'Ne jamais arrêter de grandir & d\'apprendre',
  seniors_community_learning_full: 'Ne jamais arrêter d\'apprendre ! Accédez à des tutoriels faciles à suivre, des cours en ligne et du contenu éducatif conçu spécialement pour les seniors. Apprenez à votre rythme.',
  seniors_community_learning_members: '2,1 millions de membres',
  seniors_community_learning_topic1: 'Bases de la technologie',
  seniors_community_learning_topic2: 'Arts & Artisanat',
  seniors_community_learning_topic3: 'Cours de cuisine',
  seniors_community_learning_topic4: 'Apprentissage des langues',
  seniors_community_learning_topic5: 'Loisirs',
  
  seniors_community_support: 'Groupes de soutien',
  seniors_community_support_desc: 'Trouvez compréhension & encouragement',
  seniors_community_support_full: 'Trouvez du soutien et de la compréhension auprès d\'autres personnes qui partagent des conditions de santé ou des situations de vie similaires. Partagez des expériences et recevez un soutien émotionnel.',
  seniors_community_support_members: '1,7 million de membres',
  seniors_community_support_topic1: 'Soutien santé',
  seniors_community_support_topic2: 'Soutien au deuil',
  seniors_community_support_topic3: 'Soutien aux aidants',
  seniors_community_support_topic4: 'Maladies chroniques',
  seniors_community_support_topic5: 'Bien-être mental',
  
  seniors_community_popular_topics: 'Sujets populaires :',
  seniors_community_join_btn: 'Rejoindre la communauté',
  
  seniors_benefits_title: 'Pourquoi les seniors aiment FaceTrue',
  seniors_benefits_subtitle: 'Un réseau social qui respecte et valorise votre expérience',
  
  seniors_benefit1_title: 'Pas d\'arnaques ou de fraudes',
  seniors_benefit1_desc: 'Protection IA contre les escrocs et les activités frauduleuses.',
  
  seniors_benefit2_title: 'Texte grand et clair',
  seniors_benefit2_desc: 'Interface facile à lire conçue pour un visionnage confortable.',
  
  seniors_benefit3_title: 'Support 24/7',
  seniors_benefit3_desc: 'L\'aide est toujours disponible quand vous avez besoin d\'assistance.',
  
  seniors_benefit4_title: 'Protection de la vie privée',
  seniors_benefit4_desc: 'Vos informations personnelles sont toujours gardées en sécurité et privées.',
  
  seniors_benefit5_title: 'Communauté respectueuse',
  seniors_benefit5_desc: 'Environnement positif où tout le monde se traite avec respect.',
  
  seniors_benefit6_title: 'Gratuit à utiliser',
  seniors_benefit6_desc: 'Toutes les fonctionnalités sont disponibles gratuitement pour vous.',
  
  seniors_footer_copyright: '© 2025 Communauté seniors FaceTrue',
  seniors_footer_desc: 'Un espace sûr et solidaire pour que les seniors se connectent',
};

export default common;
